import Header from "./Header";
import Landing from "./Landing";
import Testimonials from "./Testimonials";
import Bio from "./bio";
import VideoComponent from "./VideoComponent";

function App() {
  return (
    <div style={{ backgroundColor: "rgb(255, 254, 239)" }}>
      <Landing />
      <Bio />
      <VideoComponent />
      <Testimonials />
      <Header />
    </div>
  );
}

export default App;
